import React, {Component} from 'react';
import {FULL_DATE_FORMAT, SHORT_DATE_FORMAT, PARTIAL_DATE_FORMAT, PARTIAL_DATE_FORMAT_WITH_WEEKDAY} from "../../shared/helpers/formats";
import {Button, Container, Divider, Grid, Header, Icon, Responsive, Segment} from "semantic-ui-react";
import moment from "moment";

const FIRST_DAY = 0;
const LAST_DAY = 5;

export default class DateTimeSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hours: props.hours || [],
      days: props.days || null,
      excludedDates: props.excludedDates || [],
      callback: props.callback,
      daysShown: {},
      firstDate: null,
      lastDate: null,
      daysIndex: 0,
      daysRanges: [],
      baseDate: moment(),

      selectedDatetimeKey: null,
      startOfHour: true,
    };

    this.getDays = this.getDays.bind(this);
    this.getTimeDisplay = this.getTimeDisplay.bind(this);
    this.getNextUsableDate = this.getNextUsableDate.bind(this);
    this.getButtonKey = this.getButtonKey.bind(this);
    this.processHours = this.processHours.bind(this);
    this.setMinutes = this.setMinutes.bind(this);

  }

  // Updating when hours or days change.
  componentWillReceiveProps = (nextProps) => {
    const { days, hours, excludedDates, } = this.state;
    if (nextProps.hours !== hours) {
      this.setState({hours: nextProps.hours, });
    }
    if (nextProps.days !== days || nextProps.excludedDates !== excludedDates) {
      this.setState(
        {days: nextProps.days, excludedDates: nextProps.excludedDates, },
        () => {this.getDays()},
      );
    }
  };

  // Calculates next schedule date.
  getNextUsableDate = (date) => {
    let newDate = moment(date);
    const { days, excludedDates, } = this.state;
    let excludedDateCheck;
    let valid = false;
    while (!valid) {
      newDate.add(1, 'days');
      excludedDateCheck = SHORT_DATE_FORMAT.format(newDate);
      if (excludedDates.indexOf(excludedDateCheck) === -1 && (days !== 'weekdays' || [0, 6].indexOf(newDate.day()) === -1)) {
        valid = true;
      }
    }
    return newDate
  };

  // Changes the dates to appoint forward.
  handleNext = () => {
    const { daysIndex, firstDate, lastDate, daysRanges } = this.state;
    if (firstDate) {
      daysRanges.push(firstDate);
      let baseDate = moment(lastDate);
      this.getNextUsableDate(baseDate);
      this.setState(
        {daysIndex: daysIndex + 1, baseDate: baseDate, daysRanges: daysRanges, },
        () => {this.getDays()},
      )
    }
  };

  // Changes the dates to appoint backward.
  handlePrev = () => {
    const { daysIndex, daysRanges } = this.state;
    if (daysIndex > 0) {
      const baseDate = daysRanges.pop();
      this.setState(
        {daysIndex: daysIndex - 1, baseDate: baseDate, daysRanges: daysRanges, },
        () => {this.getDays()},
      )
    }
  };

  // Calculates all days/hours shown on the scheduler.
  getDays = () => {
    const { baseDate, hours, } = this.state;
    let date = baseDate;
    let daysShown = {};
    let firstDate, lastDate;
    const now = moment();
    if (now.hour() >= hours[hours.length - 1]) {
      date = this.getNextUsableDate(date);
    }
    if (date) {
      for (let i = FIRST_DAY; i < LAST_DAY; i++) {
        const display = PARTIAL_DATE_FORMAT_WITH_WEEKDAY.format(date);
        daysShown[display] = date;
        if (i === FIRST_DAY) {
          firstDate = moment(date);
        }
        else if (i === LAST_DAY - 1) {
          lastDate = moment(date);
        }
        date = this.getNextUsableDate(date);
      }
    }
    this.setState({daysShown: daysShown, firstDate: firstDate, lastDate: lastDate, });
  };

  // Filters today's hours.
  processHours = (day, hours) => {
    const {daysShown, } = this.state;
    const now = moment();
    const date = daysShown[day];
    if (date.date() === now.date() && date.month() === now.month() && date.year() === now.year()) {
      return hours.filter( (hour) => {return hour > now.hour()} )
    }
    else {
      return hours
    }
  };

  // Passes an hour to the string representation.
  getTimeDisplay = (time) => {
    const startOfHour = this.state.startOfHour;
    const isMorning = time < 12;
    const isMorningHour = time <= 12;
    let showHour = ((isMorningHour) ? time : time - 12);
    if (showHour < 10) {
      showHour = '0' + showHour.toString();
    }
    else {
      showHour = showHour.toString();
    }
    return showHour + (startOfHour ? ':00 ' : ':30 ') + ((isMorning) ? 'AM' : 'PM');
  };

  // Calculates Hour buttons unique identifier (key).
  getButtonKey = (day, hour, startOfHour) => {
    return day + '_' + hour + ':' + ((startOfHour) ? '00' : '30');
  };

  // Set minutes to be 0 or 30.
  setMinutes = (startOfHour) => {
    this.setState({startOfHour: startOfHour});
  };

  render() {
    const { daysShown, hours, callback, firstDate, lastDate, daysIndex, selectedDatetimeKey, startOfHour, } = this.state;

    return (
      <Container>
        <Segment.Group horizontal className='invisible-segment m-0'>
          <Segment>
            <Button onClick={this.handlePrev} disabled={daysIndex === 0} floated='left' icon='angle left' size='mini' />
          </Segment>
          <Segment textAlign='center' className='invisible-segment'>
            <Icon name='calendar' />
            {FULL_DATE_FORMAT.format(firstDate)} - {FULL_DATE_FORMAT.format(lastDate)}
          </Segment>
          <Segment className='invisible-segment'>
            <Button onClick={this.handleNext} floated='right' icon='angle right' size='mini' />
          </Segment>
        </Segment.Group>
        <Divider />
        <Grid columns='equal'>
          {
            Object.keys(daysShown).map(
              (day) => (
                <Grid.Column key={day} textAlign='center'>
                  <Responsive as={Header} minWidth={768} size='medium'>{day}</Responsive>
                  <Responsive as={Header} maxWidth={767} size='tiny'>{PARTIAL_DATE_FORMAT.format(daysShown[day])}</Responsive>
                  {
                    this.processHours(day, hours).map(
                      (hour) => (
                        <Container key={this.getButtonKey(day, hour, startOfHour) + '-container'} className='button-container'>
                          <Responsive
                            as={Button}
                            minWidth={768}
                            key={this.getButtonKey(day, hour, startOfHour)}
                            inverted
                            size='medium'
                            active={selectedDatetimeKey && selectedDatetimeKey === this.getButtonKey(day, hour, startOfHour)}
                            color='blue'
                            id={this.getButtonKey(day, hour, startOfHour)}
                            onClick={() => {
                              this.setState({selectedDatetimeKey: this.getButtonKey(day, hour, startOfHour)});
                              callback(daysShown[day], hour, startOfHour);
                            }}>
                            {this.getTimeDisplay(hour)}
                          </Responsive>
                          <Responsive
                            as={Button}
                            maxWidth={767}
                            key={this.getButtonKey(day, hour, startOfHour) + '-m'}
                            inverted
                            size='tiny'
                            className='small-button'
                            active={selectedDatetimeKey && selectedDatetimeKey === this.getButtonKey(day, hour, startOfHour)}
                            color='blue'
                            id={this.getButtonKey(day, hour, startOfHour) + '-m'}
                            onClick={() => {
                              this.setState({selectedDatetimeKey: this.getButtonKey(day, hour, startOfHour)});
                              callback(daysShown[day], hour, startOfHour);
                            }}>
                            {this.getTimeDisplay(hour)}
                          </Responsive>
                        </Container>
                      )
                    )
                  }
                </Grid.Column>
              )
            )
          }
        </Grid>
        <Divider hidden className='mt-0'/>
        <Container textAlign='center'>
          <Responsive
            as={Button}
            minWidth={768}
            inverted
            size='medium'
            color='blue'
            active={startOfHour}
            onClick={() => {this.setMinutes(true)}}
          >:00 times</Responsive>
          <Responsive
            as={Button}
            maxWidth={767}
            inverted
            size='tiny'
            color='blue'
            active={startOfHour}
            onClick={() => {this.setMinutes(true)}}
          >:00 times</Responsive>

          <Responsive
            as={Button}
            minWidth={768}
            inverted
            size='medium'
            color='blue'
            active={!startOfHour}
            onClick={() => {this.setMinutes(false)}}
          >:30 times</Responsive>
          <Responsive
            as={Button}
            maxWidth={767}
            inverted
            size='tiny'
            color='blue'
            active={!startOfHour}
            onClick={() => {this.setMinutes(false)}}
          >:30 times</Responsive>
        </Container>
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AppointmentApp/daysHours.js